import { render, staticRenderFns } from "./GroupFansDialog.vue?vue&type=template&id=0c8342f6&scoped=true"
import script from "./GroupFansDialog.vue?vue&type=script&lang=js"
export * from "./GroupFansDialog.vue?vue&type=script&lang=js"
import style0 from "./GroupFansDialog.vue?vue&type=style&index=0&id=0c8342f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_7d198ec714527f3eb87755d9f59e0144/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8342f6",
  null
  
)

export default component.exports